import { LEARNING_MODULES } from "@/data/appData";
import { GLOSSARY } from "@/data/glossary";
import { GLOSSARY_ES } from "@/data/glossary.es";
import { GUIDES } from "@/data/guides";
import { codeIndex } from "@/lib/codeIndex";
import { localizeModule, localizeGuide, normalizeLang } from "@/lib/localizeContent";

const cache = {};

// Flat, language-aware search index: modules, code sections, glossary terms, guides.
export function buildSearchIndex(lang) {
  const l = normalizeLang(lang);
  const es = l === "es";
  if (cache[l]) return cache[l];
  const out = [];
  for (const m of LEARNING_MODULES) {
    const { module } = localizeModule(m, l);
    out.push({ type: "module", id: m.id, title: module.title, hint: module.summary || "", to: `/learn?module=${m.id}` });
  }
  for (const g of codeIndex(l)) for (const s of g.sections) out.push({ type: "code", id: s.id, title: s.title, hint: `NFPA 72 ${s.ref.section.split(" ")[0]} · ${g.title}`, body: s.rule, to: `${es ? "/es/codigo" : "/code"}/${s.id}` });
  for (const g of GLOSSARY) {
    const tr = es ? GLOSSARY_ES[g.slug] : null;
    out.push({ type: "term", id: g.slug, title: tr?.term || g.term, hint: g.abbr || "", body: tr?.definition || g.definition, to: `${es ? "/es/glosario" : "/glossary"}/${g.slug}` });
  }
  for (const g of GUIDES) {
    const { guide } = localizeGuide(g, l);
    out.push({ type: "guide", id: g.slug, title: guide.title, hint: guide.category || "", body: guide.description || "", to: `${es ? "/es/guias" : "/guides"}/${g.slug}` });
  }
  cache[l] = out;
  return out;
}

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function searchAll(lang, query, limit = 12) {
  const q = norm(query).trim();
  if (q.length < 2) return [];
  const words = q.split(/\s+/);
  const scored = [];
  for (const item of buildSearchIndex(lang)) {
    const title = norm(item.title), hint = norm(item.hint), body = norm(item.body);
    let score = 0;
    for (const w of words) {
      if (title.includes(w)) score += title.startsWith(w) ? 6 : 4;
      else if (hint.includes(w)) score += 3;
      else if (body.includes(w)) score += 1;
      else { score = 0; break; }
    }
    if (score) scored.push({ item, score });
  }
  // Best matches first, but no single type may crowd the others out (max 5 per type).
  const perType = {};
  const out = [];
  for (const { item } of scored.sort((a, b) => b.score - a.score)) {
    if ((perType[item.type] || 0) >= 5) continue;
    perType[item.type] = (perType[item.type] || 0) + 1;
    out.push(item);
    if (out.length >= limit) break;
  }
  return out;
}
